module.exports = __webpack_public_path__ + "affhero.png?eccfc998ce9a2695a7095c1b541d9c67";